import React, { useRef } from 'react';

const ChatInput = ({ message, setMessage, onSend }) => {
  const textareaRef = useRef(null);

  // Auto-resize textarea
  const autoResize = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  // Handle send message
  const handleSend = () => {
    if (!message.trim()) return;
    onSend();
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }
  };

  return (
    <div className="pb-3 pt-2 -mb-0.5 mx-2.5 bg-white dark:bg-gray-900">
      <form className="w-full flex gap-1.5" onSubmit={(e) => { e.preventDefault(); handleSend(); }}>
        <div className="flex-1 flex flex-col relative w-full shadow-lg rounded-3xl border border-gray-50 dark:border-gray-850 hover:border-gray-100 focus-within:border-gray-100 hover:dark:border-gray-800 focus-within:dark:border-gray-800 transition px-1 bg-white/90 dark:bg-gray-400/5 dark:text-gray-100">
          
          {/* Text Input Area */}
          <div className="px-2.5">
            <textarea
              ref={textareaRef}
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
                autoResize();
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSend();
                }
              }}
              placeholder="Send a Message"
              className="scrollbar-hidden bg-transparent dark:text-gray-100 outline-hidden w-full pt-3 px-1 resize-none"
              rows={1}
            />
          </div>

          {/* Bottom Controls Bar */}
          <div className="flex justify-between mt-1 mb-2.5 mx-0.5 max-w-full">
            {/* Left side controls (attachment button, tools, etc.) */}
            <div className="ml-1 self-end flex items-center flex-1 max-w-[80%] gap-0.5">
              {/* Attachment/Paperclip button */}
              <button
                className="bg-transparent hover:bg-gray-100 text-gray-800 dark:text-white dark:hover:bg-gray-800 transition rounded-full p-1.5 outline-hidden focus:outline-hidden"
                type="button"
                aria-label="More"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="size-5"
                >
                  <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                </svg>
              </button>

              {/* Additional feature buttons */}
              <div className="flex gap-1 items-center overflow-x-auto scrollbar-none flex-1">
                {/* Feature toggle buttons here */}
              </div>
            </div>

            {/* Right side controls (voice, send button) */}
            <div className="self-end flex space-x-1 mr-1 shrink-0">
              {/* Voice input button */}
              <button
                className="text-gray-600 dark:text-gray-300 hover:text-gray-700 dark:hover:text-gray-200 transition rounded-full p-1.5 mr-0.5 self-center"
                type="button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5 translate-y-[0.5px]"
                >
                  <path d="M7 4a3 3 0 016 0v6a3 3 0 11-6 0V4z" />
                  <path d="M5.5 9.643a.75.75 0 00-1.5 0V10c0 3.06 2.29 5.585 5.25 5.954V17.5h-1.5a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-1.5v-1.546A6.001 6.001 0 0016 10v-.357a.75.75 0 00-1.5 0V10a4.5 4.5 0 01-9 0v-.357z" />
                </svg>
              </button>

              {/* Send button */}
              <div className="flex items-center">
                <button
                  className={`${!(message === '')
                    ? 'bg-black text-white hover:bg-gray-900 dark:bg-white dark:text-black dark:hover:bg-gray-100'
                    : 'text-white bg-gray-200 dark:text-gray-900 dark:bg-gray-700 disabled'
                  } transition rounded-full p-1.5 self-center`}
                  type="submit"
                  disabled={message === ''}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    className="size-5"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 14a.75.75 0 0 1-.75-.75V4.56L4.03 7.78a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.75 4.56v8.69A.75.75 0 0 1 8 14Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ChatInput;